import '@fontsource/arsenal';
import '@fontsource/nunito';
import React from 'react';
import ReactDOM from 'react-dom';
import '../node_modules/react-grid-layout/css/styles.css';
import '../node_modules/react-resizable/css/styles.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { makeUrlPathEndingWithSlash } from './utils/url-utils';

// make sure that url path ends with a slash, so that forward links travel to subfolder.
if (makeUrlPathEndingWithSlash(window.location.href.toString())) {
  console.log('replaced url', makeUrlPathEndingWithSlash(window.location.href.toString()));
  window.history.replaceState(
    null,
    document.title,
    makeUrlPathEndingWithSlash(window.location.href)
  );
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
